<template>
<div>
    <div class="connerwidth boxSizing category">
        <p class="title">
            <span class="iconfont" :class="data.iconClass"></span>
            <em v-text="data.title"></em>
        </p>
        <div keep-alive>
            <div class="categoryList" v-for="item of mylist" >
                <router-link :to="data.detailsName + item.id">
                    <div class="img">
                        <img :src="item.cover" alt="">
                        <div class="live_status" v-show="item.status === 1">
                            <div class="live_player"></div>
                            <div class="live_status_content">直播中</div>
                        </div>

                    </div>
                    <div class="text">
                        <div class="title" v-text="item.title"></div>
                        <div class="lector" v-if="item.teacher">
                            <div class="headerDesc">
                            <span class="frequency">
                            <em class="iconfont icon-shijian"></em>
                            <em >{{ item.start_time }} - {{ item.end_time }}</em>
                            </span>
                            </div>
                            <div class="lecturer">
                                <span>主讲：</span>
                                <span>
                            <em v-if="item.teacher">{{ item.teacher }}</em>
                        </span>
                            </div>
                            <div class="bottomDescription">
                                <span class="money">{{ item.charge === 0 ? "免费" : item.priceText }}</span>
                                <span class="frequency">
                                <em v-text="item.attentionCount" style="color: #ff8004;"></em>
                                <em>人报名</em>
                            </span>
                                <!-- <span class="class-hour"><em class="iconfont icon-kechengbiao"></em><em v-text="data.keshi"></em>课时</span> -->
                            </div>
                        </div>
                        <!-- <div v-else-if="item.payed" class="myvideoLi">
                            <div class="information videoDel" v-if="item.jieName==''">
                                <span class="frequency"><em class="iconfont icon-bofang"></em> <em v-text="item.redu"></em></span>
                                <span class="class-hour"><em class="iconfont icon-kechengbiao"></em><em v-text="item.keshi"></em>课时</span>
                            </div>
                            <div v-else><span class="jieName twoEllipsis" v-text="data.jieName"></span></div>
                            <div class="payinfo">
                                <span class="payed" v-if="data.payed" v-text="'已购买'"></span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="information">
                                    <span class="frequency" v-if="data.redu !== 'none'"><em class="iconfont icon-bofang"></em> <em v-text="data.redu"></em></span>
                                    <span class="class-hour"><em class="iconfont icon-kechengbiao"></em><em v-text="data.keshi"></em>课时</span>
                            </div>
                            <div class="information">
                                    <span class="money" v-if="data.money" v-text="'￥' + data.money"></span>
                            </div>
                        </div>
                        <div class="line" v-if="!data.payed">
                            <div></div>
                        </div> -->
                    </div>
                </router-link>

            </div>
        </div>
    </div>
</div>
</template>
<script>
import moment from "moment/moment.js";

export default {
    name:'hotlivelist',
    props:{ data:null, list:Array },
    data(){
        return {
            msg:'',
            mylist:'',
        }
    },
    created(){
        console.log('wang',this.data);
        this.mylist = this.list.map(item => {
                var obj = {
                    id: item.id,     //ID
                    cover: item.cover || "http://m.wm319.com/img/cover.png",   //封面
                    title: item.title,    //标题
                    teacher: item.teacher,       //主讲教师
                    start_time: moment(item.start_time).format("YYYY.MM.DD"),     //开始日期
                    end_time: moment(item.end_time).format("YYYY.MM.DD"),     //结束日期
                    channel_id: item.channel_id,     //第三方直播平台频道id
                    status: item.status || 0,
                    //status: (item.status === 1 ? "直播中": ""),     //0：未开始，1：直播中，2：已结束，3：已删除
                    synopsis: item.synopsis,     //简介图片
                    subject_id: item.subject_id,     //考试ID
                    genus_id: item.genus_id,     //科目ID
                    isAttention: item.isAttention,    //是否订阅
                    attentionCount: item.attentionCount || 0,  //报名数量
                    charge: item.charge || 0 ,     //是否免费   0免费  1收费 2已付费
                    price: item.price || 0,   //商品定价
                    priceText: '￥' + (item.price || 0),   //商品定价
                    integral_price: item.integral_price  //积分价格
                };
                //更改price（若以购买把price改为已报名）   判断怎么显示商品价格   状态有（免费、价格、已报名）三种状态
                if(obj.isAttention) { obj.priceText = '已报名'; return obj };
                return obj;
            });
    },
    watch:{
        list(newVal){
            this.mylist = newVal.map(item => {
                var obj = {
                    id: item.id,     //ID
                    cover: item.cover || "http://m.wm319.com/img/cover.png",   //封面
                    title: item.title,    //标题
                    teacher: item.teacher,       //主讲教师
                    start_time: moment(item.start_time).format("YYYY.MM.DD"),     //开始日期
                    end_time: moment(item.end_time).format("YYYY.MM.DD"),     //结束日期
                    channel_id: item.channel_id,     //第三方直播平台频道id
                    status: item.status || 0,
                    //status: (item.status === 1 ? "直播中": ""),     //0：未开始，1：直播中，2：已结束，3：已删除
                    synopsis: item.synopsis,     //简介图片
                    subject_id: item.subject_id,     //考试ID
                    genus_id: item.genus_id,     //科目ID
                    isAttention: item.isAttention,    //是否订阅
                    attentionCount: item.attentionCount || 0,  //报名数量
                    charge: item.charge || 0 ,     //是否免费   0免费  1收费 2已付费
                    price: item.price || 0,   //商品定价
                    priceText: '￥' + (item.price || 0),   //商品定价
                    integral_price: item.integral_price  //积分价格
                };
              //更改price（若以购买把price改为已报名）   判断怎么显示商品价格   状态有（免费、价格、已报名）三种状态
                if(obj.isAttention) { obj.priceText = '已报名'; return obj };
                return obj;
            });
        }
    },
    methods:{
        details(id){
            this.$router.push({ name: this.data.detailsName, params: { id: id } });
        }
    }
}
</script>

<style lang="scss" scoped>
.category {
    margin-bottom: 20px;
    background: #fff;
    /deep/ .categoryList:last-child {
      .line div {
          border-bottom: none;
      }
    }
}
.connerwidth{
    width: 100%;
    padding: 0 30px;
    font-size: 0;
}
.title {
    font-size: 0;
    display: inline-block;
    .iconfont {
        font-size: 40px;
        line-height: 90px;
        background: linear-gradient(to bottom right, #e8c9a0, #c59962);
        -webkit-background-clip: text;
        color: transparent;
        vertical-align: middle;
        display: inline-block;
        margin-right: 15px;
    }
    em {
        font-size: 33px;
        color: #333333;
        line-height: 90px;
        vertical-align: middle;
    }
}
.lecturer{
    margin-top: 10px;
    font-size: 28px;
    span {
        margin-left: 15px;
    }
    em {
        font-size: 28px;
        display: inline-block;
        margin: 0 3px;
        color: #999999;
        line-height: 1;
    }
}
.headerDesc{
    margin-top: 18px;
    margin-bottom: 15px;
    font-size: 28px;
    .money {
        font-size: 28px;
        color: #ff8004;
        line-height: 1;
    }
    span {
        margin-right: 40px;
    }
    em {
        font-size: 28px;
        display: inline-block;
        margin: 0 3px;
        color: #999999;
        line-height: 1;
    }
}
.bottomDescription{
    /*height: 40px;*/
    /*line-height: 40px;*/
    margin-top: 28px;
    font-size: 28px;
    .money {
        font-size: 28px;
        color: #ff8004;
        line-height: 1;
    }
    span {
        margin-right: 40px;
    }
    em {
        font-size: 28px;
        display: inline-block;
        margin: 0 3px;
        color: #999999;
        line-height: 1;
    }
}
.information {
    /*height: 40px;*/
    /*line-height: 40px;*/
    margin-top: 38px;
    font-size: 28px;
    .money {
        font-size: 30px;
        color: #ff8004;
        line-height: 1;
    }
    span {
        margin-right: 40px;
    }
    em {
        font-size: 28px;
        display: inline-block;
        margin: 0 3px;
        color: #999999;
        line-height: 1;
    }
}
.myvideoLi {
    font-size: 24px;
}
.payinfo {
    font-size: 24px;
    margin-top: 10px;
}
.videoDel {
    min-height: 80px;
    margin-top: 20px;
}
.jieName {
    display: block;
    min-height: 80px;
    font-size: 26px;
    color: #999;
    margin-top: 14px;
}
.payed {
    color: #ff8004;
    font-size: 24px;
}
.categoryList {
    position: relative;
    width: 100%;
    padding: 30px 0;
    box-sizing: border-box;
    cursor: pointer;
}
.img {
    width: 200px;
    background: pink;
    height: 200px;
    img{
        width: 100%;
        height: 100%;
    }
}
.text {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-left: 220px;
  overflow: hidden;
  .line {
    width: 100%;
    box-sizing: border-box;
    padding-left: 220px;
    overflow: hidden;
    div {
      width: 100%;
      box-sizing: border-box;
      margin-left: -220px;
      border-bottom: 1PX solid #e1e1e1;
    }
    position: absolute;
    bottom: 0;
  }
  .title {
    font-size: 30px;
    margin-top: 43px;
    color: #333;
    font-weight: bold;
    line-height: 1.2;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .teach {
    line-height: 1;
    font-size: 0;
    height: auto;
    margin-top: 20px;
    p {
      font-size: 24px;
      margin-right: 10px;
      text-align: center;
      color: #999;
      background: #f6f7f8;
      padding: 0 30px;
      display: inline-block;
      border-radius: 22px;
      line-height: 44px;
    }
  }

  .lector {
    line-height: 1;
    font-size: 0;
    height: auto;
    margin-top: 15px;
    p {
      font-size: 24px;
      margin-right: 10px;
      text-align: center;
      color: #999;
      // background: #f6f7f8;
      padding: 0 30px;
      display: inline-block;
      // border-radius: 22px;
      line-height: 44px;
    }
  }
}
.class-hour {
    color: #999;
}
.live_status{
    border-radius: 1rem 1rem 1rem 1rem;
    width: 1rem;
    height: 1rem;
    position: absolute;
    top: 0.75rem;
    background-color: #ddd;
    left: 0.5rem;
    opacity: 0.9;
}
.live_player{
    position: absolute;
    height: 0rem;
    border-style: solid;
    border-width: 0.3rem 0 0.3rem 0.4rem;
    border-color: transparent transparent transparent black;
    left: 0.355rem;
    top: 0.22rem;
}
.live_status_content{
    // border: solid 1px red;
    color: #FF8051;
    position: absolute;
    top: 1.1rem;
    width: 1rem;
    height: 0.4rem;
    text-align: center;
    font-size: 0.28rem;
    opacity: unset;
}
</style>
